import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="header" hl-sticky="" ng-click="vm.closeMenu()">
            <button type="button" class="close" ng-if="vm.inFrame" ng-click="vm.closeReview()">Close</button>
            <div class="row2">
                <div class="col00 small">
                    <div class="heading01">
                        <h1>
                            <img
                                ng-if="vm.company.logoFilename"
                                ng-src="{{ vm.CompanyService.getLogoImage(vm.company.logoFilename, vm.company.id, 'smallHeaderLogo') }}"
                                height="40"
                            >
                        </h1>
                        <p class="center">{{ vm.MomentService.formatDate(vm.review.reviewDate) }}, {{ vm.review.room.name }}
                            <strong>{{ vm.review.user.displayName }}</strong> {{ 'performanceReview.Performance review' | translate }}
                        </p>
                        <div class="quizdata" ng-if="vm.review.form.isMultiLanguage">
                          <select class="form-control"
                                  ng-model="vm.language"
                                  ng-change="vm.changeLanguage()"
                                  ng-options="code.toLowerCase() as language for (code, language) in vm.languages track by code.toLowerCase()">
                          </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    `
})
export default class {
    constructor ($translate, $rootScope, lodash, CompanyResource, UserResource, CompanyService, MomentService,
                 TranslationService, ModalService, TokenService,
                 COMPANY_LANGUAGE_ENUM, USER_SWITCH_LANGUAGE_SOURCE_ENUM) {
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.lodash = lodash;
        this.UserResource = UserResource;
        this.CompanyService = CompanyService;
        this.TranslationService = TranslationService;
        this.ModalService = ModalService;
        this.MomentService = MomentService;
        this.TokenService = TokenService;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.USER_SWITCH_LANGUAGE_SOURCE_ENUM = USER_SWITCH_LANGUAGE_SOURCE_ENUM;

        $rootScope.$on('review', (event, review) => {
            this.review = review;
            if (!this.company) {
                CompanyResource.publicView({ id: this.review.companyId }).$promise.then(company => {
                    this.company = company;
                });
            }
            if (this.review.user) {
                this.language = this.review.preferredLanguage.toLowerCase();
            }
            else {
                this.language = this.$translate.use();
            }
            this.changeLanguage();
        });
    }

    $onInit () {
        this.inFrame = self !== top;
    }

    loadLanguages () {
        this.languages = this.lodash.pick(this.COMPANY_LANGUAGE_ENUM.DROPDOWN_LABELS_IN_NATIVE, [
            this.COMPANY_LANGUAGE_ENUM.KEYS.ET, this.COMPANY_LANGUAGE_ENUM.KEYS.EN
        ]);

        // in case there is no option for preferred language fallback to company language
        if (!this.languages[this.language.toUpperCase()]) {
            this.language = this.review.companyLanguage.toLowerCase();
            this.$translate.use(this.language);
        }
    }

    changeLanguage () {
        this.$rootScope.language = this.language;
        this.TranslationService.changeLanguage(this.language).then((data) => {
            this.UserResource
                .switchCoursyLocale({
                    coursyLanguage: this.language.toUpperCase(),
                    switchSourceType: this.USER_SWITCH_LANGUAGE_SOURCE_ENUM.KEYS.PERFORMANCE_REVIEW,
                    switchSourceGuid: this.$rootScope.review.guid,
                    isManager: this.$rootScope.review.isManager
                })
                .$promise
                .then(() => {
                    this.$rootScope.$emit('review:language', data);
                    this.loadLanguages();
                });
        });
    }

    // sends post message to parent window to close iframe
    closeReview () {
        if (this.inFrame) {
            this.ModalService.confirm(this.$translate.instant('review.Close review?'), 'small').then(() => {
                parent.postMessage('closeOverlay()', '*');
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/header/review/index.js